<template>
  <w-icon-wrapper
    :width="24" 
    :height="22.12"
    viewBox="0 0 24 22.12"  
    icon-name='work-bulk-execute-selection-icon'
  >
    <g
      id="Gruppe_3"
      data-name="Gruppe 3"
    >
      <path
        id="Pfad_1"
        data-name="Pfad 1"
        d="M21.99,12.52v2.34H19.66a.555.555,0,0,1,0-1.11h.35a3.886,3.886,0,0,0-1.03-.59,4.847,4.847,0,0,0-.61-.2,4.125,4.125,0,0,0-4.92,3.12,3.922,3.922,0,0,0-.07,1.4l.02.14H12.29l-.01-.11a5.1,5.1,0,0,1,.1-1.68,5.222,5.222,0,0,1,6.24-3.93,6.3,6.3,0,0,1,.78.24,5.368,5.368,0,0,1,1.48.91v-.53a.555.555,0,0,1,.12-.33.544.544,0,0,1,.44-.22.555.555,0,0,1,.55.55"
        fill="currentColor"
      />
      <path
        id="Pfad_2"
        data-name="Pfad 2"
        d="M22.37,18.06a5.2,5.2,0,0,1-5.08,4.06,5.094,5.094,0,0,1-1.16-.13,5.9,5.9,0,0,1-.77-.23,5.362,5.362,0,0,1-1.49-.92v.53a.507.507,0,0,1-.15.36.533.533,0,0,1-.41.19.555.555,0,0,1-.55-.55V19.04h2.33a.545.545,0,1,1,0,1.09h-.35a3.8,3.8,0,0,0,1.03.6,3.941,3.941,0,0,0,.61.2,4.12,4.12,0,0,0,4.92-3.11,3.943,3.943,0,0,0,.07-1.4l-.02-.14h1.11l.01.11a5.029,5.029,0,0,1-.1,1.67"
        fill="currentColor"
      />
      <path
        id="Pfad_3"
        data-name="Pfad 3"
        d="M0,0V19.99H12.14a5.59,5.59,0,0,1-.77-2H9.12V14.01h2.87a5.873,5.873,0,0,1,1.77-2H9.12V8.02H22v3.32a4.568,4.568,0,0,1,.58.67,6.455,6.455,0,0,1,1.08,2A6.664,6.664,0,0,1,24,16.12V0ZM7.12,17.99H2V14.01H7.12Zm0-5.98H2V8.02H7.12Zm0-5.99H2V2H7.12ZM22,6.02H9.12V2H22Z"
        fill="currentColor"
      />
      <path
        id="Pfad_4"
        data-name="Pfad 4"
        d="M19.5,5h-8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2"
        fill="currentColor"
      />
      <path
        id="Pfad_5"
        data-name="Pfad 5"
        d="M20.5,10a1,1,0,0,1-1,1h-8a1,1,0,0,1,0-2h8a1,1,0,0,1,1,1"
        fill="currentColor"
      />
      <path
        id="Pfad_6"
        data-name="Pfad 6"
        d="M4.063,17.582,2.771,16.291a.5.5,0,1,1,.707-.707l.585.584,1.458-1.459a.5.5,0,0,1,.707.707Z"
        fill="currentColor"
      />
      <path
        id="Pfad_7"
        data-name="Pfad 7"
        d="M4.063,11.644,2.771,10.353a.5.5,0,0,1,.707-.707l.585.584L5.521,8.771a.5.5,0,0,1,.707.707Z"
        fill="currentColor"
      />
      <path
        id="Pfad_8"
        data-name="Pfad 8"
        d="M4.063,5.582,2.771,4.291a.5.5,0,1,1,.707-.707l.585.584L5.521,2.709a.5.5,0,0,1,.707.707Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconBulkExecuteSelection' };
</script>
